export const fallbackData = {
    surplus: {
      low: {
        stores: 0,
        'grid-points': 0,
        contribution: 0,
        details: {
          sales: { value: 0, pcs: 0 },
          "gross-margin": { value: 0, pcs: 0 },
          'planned-range': { value: 0, pcs: 0 },
          'range-available': { value: 0, pcs: 0 },
          gap: { value: 0, pcs: 0 }
        }
      },
      medium: {
        stores: 0,
        'grid-points': 0,
        contribution: 0,
        details: {
          sales: { value: 0, pcs: 0 },
          "gross-margin": { value: 0, pcs: 0 },
          'planned-range': { value: 0, pcs: 0 },
          'range-available': { value: 0, pcs: 0 },
          gap: { value: 0, pcs: 0 }
        }
      },
      high: { stores: 0, 'grid-points': 0, contribution: 0 }
    },
    complete: {
      low: {
        stores: 0,
        'grid-points': 0,
        contribution: 0,
        details: {
          sales: { value: 0, pcs: 0 },
          "gross-margin": { value: 0, pcs: 0 },
          'planned-range': { value: 0, pcs: 0 },
          'range-available': { value: 0, pcs: 0 },
          gap: { value: 0, pcs: 0 }
        }
      },
      medium: {
        stores: 0,
        'grid-points': 0,
        contribution: 0,
        details: {
          sales: { value: 0, pcs: 0 },
          "gross-margin": { value: 0, pcs: 0 },
          'planned-range': { value: 0, pcs: 0 },
          'range-available': { value: 0, pcs: 0 },
          gap: { value: 0, pcs: 0 }
        }
      },
      high: { stores: 0, 'grid-points': 0, contribution: 0 }
    },
    incomplete: {
      low: {
        contribution: 0,
        initial: { stores: 0, 'grid-points': 0 },
        available: {
          stores: 0,
          'grid-points': 0,
          details: {
            sales: { value: 0, pcs: 0 },
            "gross-margin": { value: 0, pcs: 0 },
            'planned-range': { value: 0, pcs: 0 },
            'range-available': { value: 0, pcs: 0 },
            gap: { value: 0, pcs: 0 }
          }
        }
      },
      medium: {
        contribution: 0,
        initial: { stores: 0, 'grid-points': 0 },
        available: {
          stores: 0,
          'grid-points': 0,
          details: {
            sales: { value: 0, pcs: 0 },
            "gross-margin": { value: 0, pcs: 0 },
            'planned-range': { value: 0, pcs: 0 },
            'range-available': { value: 0, pcs: 0 },
            gap: { value: 0, pcs: 0 }
          }
        }
      },
      high: {
        contribution: 0,
        initial: { stores: 0, 'grid-points': 0 },
        available: {
          stores: 0,
          'grid-points': 0,
          details: {
            sales: { value: 0, pcs: 0 },
            "gross-margin": { value: 0, pcs: 0 },
            'planned-range': { value: 0, pcs: 0 },
            'range-available': { value: 0, pcs: 0 },
            gap: { value: 0, pcs: 0 }
          }
        }
      }
    },
    'very-incomplete': {
      low: {
        contribution: 0,
        initial: { stores: 0, 'grid-points': 0 },
        available: {
          stores: 0,
          'grid-points': 0,
          details: {
            sales: { value: 0, pcs: 0 },
            "gross-margin": { value: 0, pcs: 0 },
            'planned-range': { value: 0, pcs: 0 },
            'range-available': { value: 0, pcs: 0 },
            gap: { value: 0, pcs: 0 }
          }
        }
      },
      medium: {
        contribution: 0,
        initial: { stores: 0, 'grid-points': 0 },
        available: {
          stores: 0,
          'grid-points': 0,
          details: {
            sales: { value: 0, pcs: 0 },
            "gross-margin": { value: 0, pcs: 0 },
            'planned-range': { value: 0, pcs: 0 },
            'range-available': { value: 0, pcs: 0 },
            gap: { value: 0, pcs: 0 }
          }
        }
      },
      high: {
        contribution: 0,
        initial: { stores: 0, 'grid-points': 0 },
        available: {
          stores: 0,
          'grid-points': 0,
          details: {
            sales: { value: 0, pcs: 0 },
            "gross-margin": { value: 0, pcs: 0 },
            'planned-range': { value: 0, pcs: 0 },
            'range-available': { value: 0, pcs: 0 },
            gap: { value: 0, pcs: 0 }
          }
        }
      }
    }
  };